import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import './candidate160.css';
import './candidate161.css';
import './candidate162.css';
import './design-system/index.css';
import { startBuildFreshnessMonitor } from './build-freshness';

startBuildFreshnessMonitor();

async function applyRuntimeBrandingMode() {
  // Runtime health reports the environment's default branding policy. Candidate
  // 143 keeps Nuramend Standard as the staging default while allowing saved
  // tenant palettes to render so branding can be QA'd before production.
  document.documentElement.dataset.nuramendBrandingMode = 'tenant';
  try {
    const response = await fetch('/api/v1/health/live', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) return;
    const health = await response.json() as { brandingMode?: string };
    document.documentElement.dataset.nuramendBrandingMode = health.brandingMode === 'standard' ? 'standard' : 'tenant';
  } catch {
    // Theme bootstrap is supplemental; application routing must still load if
    // the public liveness probe is temporarily unavailable.
  }
}

void applyRuntimeBrandingMode();

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
